// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"107":"202b0e62","413":"d19cb543","787":"139d1b61"}[chunkId] + ".chunk.js";
};